var SELECTOR = 'span.jump-link[data-title]';
var MOBILE_BREAKPOINT = 768;

function init() {
    try {
        var nav = document.querySelector('.auto-anchor-nav');
        if (!nav) return;

        var registry = {};
        var activeId = null;
        var currentMode = null; // 'tabs' or 'dropdown'

        // ─── Registry helpers ────────────────────────────────────────────

        function getSortedIds() {
            return Object.keys(registry).sort(function (a, b) {
                return registry[a].section.getBoundingClientRect().top
                    - registry[b].section.getBoundingClientRect().top;
            });
        }

        function setActive(id) {
            activeId = id;
            if (currentMode === 'tabs') {
                Object.keys(registry).forEach(function (key) {
                    registry[key].link.classList.toggle('active', key === id);
                    registry[key].link.setAttribute('aria-current', key === id ? 'true' : 'false');
                });
            } else if (currentMode === 'dropdown') {
                var select = nav.querySelector('select');
                if (select && id) {
                    select.value = id;
                }
            }
        }

        function addLink(anchor) {
            var id = anchor.id;
            var title = anchor.getAttribute('data-title');
            if (!id || !title) return;
            if (registry[id]) return;

            var icon = anchor.getAttribute('data-icon');
            var section = anchor.nextElementSibling || anchor.parentElement;
            registry[id] = { anchor: anchor, section: section, title: title, icon: icon, link: null };

            if (Object.keys(registry).length > 1) {
                nav.classList.add('auto-anchor-nav--visible');
            }

            renderMode(currentMode);
        }

        // ─── Tabs UI (desktop) ───────────────────────────────────────────

        function buildTabs() {
            nav.innerHTML = '';
            nav.classList.remove('auto-anchor-nav--dropdown');
            nav.classList.add('auto-anchor-nav--tabs');

            var sorted = getSortedIds();
            sorted.forEach(function (id) {
                var entry = registry[id];
                var a = document.createElement('a');
                a.className = 'tablinks u-color-black u-txt-center';
                a.href = '#' + id;
                a.setAttribute('aria-current', activeId === id ? 'true' : 'false');
                if (activeId === id) a.classList.add('active');
                if (entry.icon) {
                    var img = document.createElement('img');
                    img.className = 'tablinks__icon u-mrg-right-qtr';
                    img.src = entry.icon;
                    img.alt = '';
                    a.appendChild(img);
                }
                var span = document.createElement('span');
                span.textContent = entry.title;
                a.appendChild(span);
                entry.link = a;
                nav.appendChild(a);
            });
        }

        // ─── Dropdown UI (mobile) ────────────────────────────────────────

        function buildDropdown() {
            nav.innerHTML = '';
            nav.classList.remove('auto-anchor-nav--tabs');
            nav.classList.add('auto-anchor-nav--dropdown');

            var wrapper = document.createElement('div');
            wrapper.className = 'fx-select';

            var label = document.createElement('label');
            label.className = 'visuallyhidden';
            label.setAttribute('for', 'auto-anchor-nav-select');
            label.textContent = 'Jump to section';

            var select = document.createElement('select');
            select.id = 'auto-anchor-nav-select';

            var sorted = getSortedIds();
            sorted.forEach(function (id) {
                var option = document.createElement('option');
                option.value = id;
                option.textContent = registry[id].title;
                if (id === activeId) option.selected = true;
                select.appendChild(option);
            });

            select.addEventListener('change', function () {
                var target = document.getElementById(select.value);
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                    setActive(select.value);
                }
            });

            wrapper.appendChild(label);
            wrapper.appendChild(select);
            nav.appendChild(wrapper);

            // Clear stale link references (not used in dropdown mode)
            Object.keys(registry).forEach(function (key) {
                registry[key].link = null;
            });
        }

        // ─── Mode switching ──────────────────────────────────────────────

        function renderMode(mode) {
            if (Object.keys(registry).length < 2) return;
            currentMode = mode;
            if (mode === 'tabs') {
                buildTabs();
            } else {
                buildDropdown();
            }
        }

        function getMode() {
            if (nav.classList.contains('auto-anchor-nav--force-tabs')) return 'tabs';
            if (nav.classList.contains('auto-anchor-nav--force-dropdown')) return 'dropdown';
            return window.innerWidth >= MOBILE_BREAKPOINT ? 'tabs' : 'dropdown';
        }

        function checkMode() {
            var mode = getMode();
            if (mode !== currentMode) {
                renderMode(mode);
            }
        }

        // ─── Sticky positioning ──────────────────────────────────────────

        var header = document.getElementsByTagName("header")[0];

        function updateStickyTop() {
            if (header) {
                nav.style.top = header.offsetHeight + 'px';
            }
        }

        // ─── Sticky detection ────────────────────────────────────────────

        var stickyObserver = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (e) {
                    nav.classList.toggle('scrolling', e.intersectionRatio < 1);
                });
            },
            { rootMargin: '-1px 0px 0px 0px', threshold: [1] }
        );
        stickyObserver.observe(nav);

        // ─── Scroll spy ──────────────────────────────────────────────────

        var ticking = false;

        function onScroll() {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
                ticking = false;
                try {
                    var threshold = window.innerHeight * 0.40;
                    var ids = getSortedIds();
                    for (var i = ids.length - 1; i >= 0; i--) {
                        var section = registry[ids[i]].section;
                        if (!section) continue;
                        if (section.getBoundingClientRect().top <= threshold) {
                            setActive(ids[i]);
                            return;
                        }
                    }
                    if (ids.length) {
                        var first = registry[ids[0]].section;
                        if (first && first.getBoundingClientRect().top < window.innerHeight) {
                            setActive(ids[0]);
                            return;
                        }
                    }
                    setActive(null);
                } catch (e) {
                    console.error('[auto-anchor-nav]', e);
                }
            });
        }

        // ─── Resize handler (mode + sticky) ──────────────────────────────

        window.addEventListener('resize', function () {
            requestAnimationFrame(function () {
                updateStickyTop();
                checkMode();
            });
        });

        // ─── Click handler (tabs mode) ───────────────────────────────────

        nav.addEventListener('click', function (e) {
            var link = e.target.closest('.tablinks');
            if (!link) return;
            var id = link.getAttribute('href').replace('#', '');
            setActive(id);
        });

        // ─── Init ────────────────────────────────────────────────────────

        currentMode = getMode();
        document.querySelectorAll(SELECTOR).forEach(addLink);
        updateStickyTop();
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();

        // MutationObserver: pick up anchors added to <main> after initial load
        var main = document.querySelector('main');
        if (main) {
            new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    mutation.addedNodes.forEach(function (node) {
                        if (node.nodeType !== Node.ELEMENT_NODE) return;
                        if (node.matches(SELECTOR)) addLink(node);
                        node.querySelectorAll(SELECTOR).forEach(addLink);
                    });
                });
            }).observe(main, { childList: true, subtree: true });
        }
    } catch (e) {
        console.error('[auto-anchor-nav]', e);
    }
}

export { init };
